export default {
  es_CL: '$0,0.[00]',
  es_MX: '$0,0.00',
  es_PE: '$0,0.00',
  es_CO: '$0,0.[00]',
  es_EC: '$0,0.[00]',
  es_CR: '$0,0.[00]'

  /* Implementar CR: money format */
  /* Implementar EC: money format */
}
